import classNames from "classnames";
import CartSummary from "./cart-summary";
import PickUpData from "./pick-up-data";
import PickUpPoints from "./pick-up-points";
import PickUpSubmit from "./pick-up-submit";
import PickUpSummary from "./pick-up-summary";
import PickUpTimeSlots from "./pick-up-time-slots";
import PickUpAlreadyBooked from "./pick-up-already-booked";
import Translate from "../translate";
import { useContext, useMemo, useState } from "react";
import CartContext from "../../context/cart";
import PickUpSede from "./pick-up-sede";
import CartDelivered from "./cart-delivered";
import CartHomeDelivery from "./cart-home-delivery";
import CartDeliveryFallback from "./cart-delivery-fallback";
import CartThirdStream from "./cart-third-stream";
import CartNotSelected from "./cart-not-selected";
import CartBookingForm from "./cart-booking-form";

const PickUpPointBookingPhase = () => {
  const { labels, survey, currentSectionIndex, slotNotAvailable, cartRequest } =
    useContext(CartContext);
  const section = useMemo(
    () =>
      survey?.definition?.sections?.[
        /* cartRequest?.deliveryOption === "INDIRIZZO"
          ? currentSectionIndex > 0
            ? currentSectionIndex + 6
            : currentSectionIndex + 3
          :  */
        currentSectionIndex < 3 ? currentSectionIndex + 3 : currentSectionIndex + 2
      ],
    [survey, currentSectionIndex]
  );
  const showCondition = useMemo(
    () =>
      cartRequest?.deliveryOption === "INDIRIZZO"
        ? true
        : ![-5, -3, -2, -1, 2].includes(currentSectionIndex) &&
          !(currentSectionIndex === 4 && slotNotAvailable),
    [cartRequest, currentSectionIndex, slotNotAvailable]
  );

  // Stato di appoggio per non modificare interamente il contesto del carrello quando l'utente vuole cambiare qualcosa in fase 2.
  // L'idea è di NON chiamare la mutation che modifica la cartRequest finché non viene confermato l'orario di recupero al pickup point,
  // perché il backend non riesce a gestire coerentemente gli stati intermedi
  // Dalla conferma dell'orario in poi ci sono i campi aggiuntivi da backend che tengono traccia dell'ultima prenotazione
  const [tempCartToSubmit, setTempCartToSubmit] = useState(undefined);
  const [tempBookingDate, setTempBookingDate] = useState(undefined);

  return (
    <div
      className={classNames(
        "wrapper page-content",
        ([-5, -3, -2, -1, 0, 4].includes(currentSectionIndex) ||
          ([1, -4].includes(currentSectionIndex) && cartRequest?.deliveryOption === "INDIRIZZO")) &&
          "wrapper-small",
        (cartRequest?.deliveryOption === "INDIRIZZO"
          ? currentSectionIndex === 2
          : currentSectionIndex === 3) && "page-summary"
      )}
    >
      <div className="cart-step-body">
        {currentSectionIndex >= 0 && (
          <span className="app-content__step">
            {labels?.WELFARE_STEP || "Step"} {currentSectionIndex + 1}
          </span>
        )}
        {showCondition && (
          <h2 className="carrello-content__title">
            <Translate text={section?.label} />
          </h2>
        )}
        {showCondition && section?.description && (
          <div
            className={classNames(
              "carrello-content__text",
              ((cartRequest?.deliveryOption === "PUNTO_VENDITA" && currentSectionIndex === 3) ||
                (cartRequest?.deliveryOption === "INDIRIZZO" &&
                  [1, 2].includes(currentSectionIndex))) &&
                "carrello-content__text--red"
            )}
          >
            <Translate html={section?.description} />
          </div>
        )}
        {
          {
            "-5": <CartNotSelected />,
            "-3": <CartDeliveryFallback />,
            "-2": <CartDelivered />,
            "-1": <PickUpSede />,
            0: <PickUpData setTempCartToSubmit={setTempCartToSubmit} />,
            ...(cartRequest?.deliveryOption === "INDIRIZZO"
              ? {
                  1: <CartHomeDelivery />,
                  2: <PickUpSummary />,
                  3: <PickUpSubmit />,
                  "-4": <CartThirdStream secondPhase={true} />,
                }
              : {
                  1: (
                    <PickUpPoints
                      tempCartToSubmit={tempCartToSubmit}
                      setTempCartToSubmit={setTempCartToSubmit}
                      setTempBookingDate={setTempBookingDate}
                    />
                  ),
                  2: (
                    <PickUpTimeSlots
                      tempCartToSubmit={tempCartToSubmit}
                      setTempBookingDate={setTempBookingDate}
                    />
                  ),
                  3: (
                    <PickUpSummary
                      tempCartToSubmit={tempCartToSubmit}
                      setTempCartToSubmit={setTempCartToSubmit}
                      tempBookingDate={tempBookingDate}
                      setTempBookingDate={setTempBookingDate}
                    />
                  ),
                  4: slotNotAvailable ? <PickUpAlreadyBooked /> : <PickUpSubmit />,
                }),
          }[currentSectionIndex]
        }
        {(cartRequest?.deliveryOption === "INDIRIZZO"
          ? [2, 3].includes(currentSectionIndex)
          : currentSectionIndex === 3 ||
            (currentSectionIndex === -1 && !cartRequest.defaultCartAssigned) ||
            (currentSectionIndex === 4 && !slotNotAvailable)) && (
          <CartSummary readOnly={true} variant={currentSectionIndex === -1 ? "reminder" : null} />
        )}
        {/* {currentSectionIndex === -1 && (
          <div
            className="carrello-content__text carrello-content__text--border-top"
            dangerouslySetInnerHTML={{
              __html:
                labels?.WELFARE_CONTACT_US_INFO ||
                "<p>Per ulteriori informazioni:<br/><strong>Welfare EssilorLuxottica</strong><br/><a href='mailto:welfare@essilorluxottica.com'>welfare@essilorluxottica.com</a></p>",
            }}
          />
        )} */}
      </div>
      {(cartRequest?.deliveryOption === "INDIRIZZO"
        ? currentSectionIndex === 2
        : currentSectionIndex === 3) && (
        <div className="cart-step-sidebar">
          <CartSummary readOnly={true} variant={currentSectionIndex === -1 ? "reminder" : null} />
          <CartBookingForm
            tempCartToSubmit={tempCartToSubmit}
            setTempCartToSubmit={setTempCartToSubmit}
            tempBookingDate={tempBookingDate}
            setTempBookingDate={setTempBookingDate}
          />
        </div>
      )}
    </div>
  );
};

export default PickUpPointBookingPhase;
